import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'ruleOutlierFilter',
    standalone: false
})
export class RuleOutlierFilterPipe implements PipeTransform {

  transform(
    arr: any[], uslLsl: boolean, rule1: boolean, rule6: boolean, rule7: boolean, enableOutlier: boolean, obiousOutlier: boolean,
    yzoom: any, isHistogram: boolean
  ): any {
    let res = arr;
    if (arr && arr.length) {
      res = res.filter(
        elem => {
          if ((obiousOutlier && !elem.manualOutlier) || enableOutlier ||
            (!obiousOutlier && !enableOutlier && !elem.outlier && !elem.manualOutlier)) {
            return elem;
          }
        }
      );
      return res;
    }
  }
}
